export enum RatingType {
  CRITICISM = 'CRITICISM',
  SUGGESTION = 'SUGGESTION',
  COMPLIMENT = 'COMPLIMENT'
}
